import { fork, call, put, take, select } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get areas
 * */
// const watchGetAreas = callBaseSaga({
//     actionName: 'GET_AREAS',
//     methodApi: 'getAreas',
//     notificationOptions: {},
// });


export function* getAreas() {
    const response = yield call(api.getAreas);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_AREAS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_AREAS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetAreas() {
    while (true) {
        yield take(actionTypes.GET_AREAS.REQUEST);
        yield fork(getAreas);
    }
}


export function* updateArea(item) {
    const requestItem = {
        ...item,
    };
    const response = yield call(api.updateArea, requestItem);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_AREA.SUCCESS,
            item: {
                ...requestItem,
                ...response.data.data, // lol more nested 'data' pls
            },
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${item.name} updated`,
                level: 'success',
                _id: item._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.UPDATE_AREA.FAILURE,
        item,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: item._id,
            autoDismiss: 2,
        },
    });
}

export function* watchUpdateArea() {
    while (true) {
        const { item } = yield take(actionTypes.UPDATE_AREA.REQUEST);
        yield fork(updateArea, item);
    }
}

export function* updateAreaAlt(item) {
    const response = yield call(api.updateAreaAlt, item);
    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_AREA_ALT.SUCCESS,
            item: response.item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.item.name} updated`,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.UPDATE_AREA_ALT.FAILURE,
        item: response.item,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: response.item._id,
            autoDismiss: 2,
        },
    });
}

export function* watchUpdateAreaAlt() {
    while (true) {
        const { item } = yield take(actionTypes.UPDATE_AREA_ALT.REQUEST);
        yield fork(updateAreaAlt, item);
    }
}

export function* createArea(item) {
    const response = yield call(api.createArea, item);

    if (response.status === 200) {
        yield put({
            type: actionTypes.CREATE_AREA.SUCCESS,
            item: {
                ...item,
                ...response.data.data,
            },
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${item.name} created`,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response.data.data;
    }

    yield put({
        type: actionTypes.CREATE_AREA.FAILURE,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });
}

export function* watchCreateArea() {
    while (true) {
        const { item } = yield take(actionTypes.CREATE_AREA.REQUEST);
        yield fork(createArea, item);
    }
}

export function* transformAreaToPort(id = null, data) {
    const response = yield call(api.transformAreaToPort, id, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.data.message}`,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });

    return response;
}

export function* deleteArea(item) {
    const response = yield call(api.deleteArea, item);

    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_AREA.SUCCESS,
            item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.data.message}`,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.DELETE_AREA.FAILURE,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });
}

export function* watchDeleteArea() {
    while (true) {
        const { item } = yield take(actionTypes.DELETE_AREA.REQUEST);
        yield fork(deleteArea, item);
    }
}

export function* removeAreaChild(parentId, childId) {
    const parent = yield select(state => state.areas.items.find(item => item._id === parentId));

    const requestItem = {
        _id: parent._id,
        name: parent.name,
        childs: parent.childs.filter(id => id !== childId),
    };
    const response = yield call(api.updateArea, requestItem);

    if (response.status === 200) {
        yield put({
            type: actionTypes.REMOVE_AREA_CHILD.SUCCESS,
            parentId,
            childId,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${parent.name} updated`,
                level: 'success',
                _id: parent._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.REMOVE_AREA_CHILD.FAILURE,
        parentId,
        childId,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: parent._id,
            autoDismiss: 2,
        },
    });
}

export function* watchRemoveAreaChild() {
    while (true) {
        const { parentId, childId } = yield take(actionTypes.REMOVE_AREA_CHILD.REQUEST);
        yield fork(removeAreaChild, parentId, childId);
    }
}

export default [watchGetAreas, watchUpdateArea, watchUpdateAreaAlt, watchCreateArea, watchDeleteArea, watchRemoveAreaChild];



// WEBPACK FOOTER //
// ./app/sagas/regions/areas.js